import React, { useEffect, useRef, useState, useCallback } from "react";
import "./main.scss";
import styles from "./award.module.scss";
import client from "../client";
import { PortableText } from "@portabletext/react";
import portableTextComponents from "../config/portableTextComponents";
import ImageLoader from "../components/content/ImageLoader";
import LinkButton from "../components/ui/LinkButton";
import { Route, Routes } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { useLocation } from "react-router-dom";


const Award = () => {
  const [pageData, setPageData] = useState(null);
  const location = useLocation();
  const titles = useRef();

  
  const fetchPageData = useCallback(async () => {
    const query = `    
    *[_id == "award"][0]{
      ...,
        awards[] {
          ...,
          image {
            ...,
            asset-> {
            url,
            metadata 
          }
        }
      }
    }`;
    client
      .fetch(query)
      .then((data) => {
        console.log(data);
        setPageData(data);
      })
      .catch(console.error);
  }, [setPageData]);

  useEffect(() => {
    if (!pageData) {
      fetchPageData();
    }
  }, [pageData, fetchPageData]);


  if (pageData) {
    return (
      <main className={`main ${styles.main}`}>
        <section className={styles.about}>
          <h3>ABOUT THE PHD AWARDS</h3>
          <PortableText
            value={pageData?.intro}
            components={portableTextComponents}
          />
        </section>
        <section className={styles.topics}>
          <h3 ref={titles}>PAST WINNERS</h3>
          <div className={styles.topicTitles}>
            {pageData?.awards.map((award, index) => (
              <div
                className={styles.topicTitlesLinkButtonContainer}
                key={index}
              >
                <LinkButton
                  link={award.year.toString()}
                  text={award.year}
                  forceActive={
                    index === 0 && location.pathname === "/phd-award"
                  }
                />
              </div>
            ))}
          </div>
          <AnimatePresence exitBeforeEnter inital={false}>
            <Routes location={location} key={location.pathname}>
              <Route
                index
                element={
                  <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { delay: 0.3 } }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    className={styles.award}
                  >
                    {pageData.awards[0].winners.map((winner, index) => (
                        <div className={styles.winner}>
                         <div className={styles.name}>
                          <LinkButton
                            link={winner.link}
                            text={winner.name}
                            external={true}
                            forceActive={true}
                          />
                        </div>
                          <div className={styles.university}><p>{winner.university}</p></div>
                          <div className={styles.title}><p>{winner.title}</p></div>
                        </div>
                      ))}
                      <div className={styles.image}>
                        <ImageLoader
                            image={pageData.awards[0].image}
                            width={400}
                            height={400}
                            bw
                          />
                        </div>
                  </motion.div>
                }
              />
              {pageData?.awards.map((award, index) => (
                <Route
                  path={award.year.toString()}
                  key={index}
                  element={
                    <motion.div
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1, transition: { delay: 0.3 } }}
                      exit={{ opacity: 0 }}
                      transition={{ duration: 0.3 }}
                      className={styles.award}
                    >
                      {award.winners.map((winner, index) => (
                        <div className={styles.winner} key={index}>
                          <div className={styles.name}>
                          <LinkButton
                            link={winner.link}
                            text={winner.name}
                            forceActive={true}
                            external={true}
                          />
                        </div>
                          <div className={styles.university}><p>{winner.university}</p></div>
                          <div className={styles.title}><p>{winner.title}</p></div>
                        </div>
                      ))}
                       <div className={styles.image}>
                        <ImageLoader
                            image={award.image}
                            width={400}
                            height={400}
                            bw
                          />
                        </div>
                    </motion.div>
                  }
                />
              ))}
            </Routes>
          </AnimatePresence>
        </section>
      </main>
    );
  }

  return null;
};

export default Award;
